/* Robusta Theme — light interactions */
(function () {
  'use strict';

  // Lucide icons — render <i data-lucide="..."> as SVGs (script loaded with defer)
  function renderLucide(root) {
    if (!(window.lucide && typeof window.lucide.createIcons === 'function')) return;
    try {
      if (root) {
        window.lucide.createIcons({ root: root });
      } else {
        window.lucide.createIcons();
      }
    } catch (e) {
      try { window.lucide.createIcons(); } catch (e2) {}
    }
  }
  function bootLucide() {
    renderLucide();
    // Se o CDN atrasar, tenta de novo
    var tries = 0;
    var t = window.setInterval(function () {
      tries += 1;
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        renderLucide();
        window.clearInterval(t);
      } else if (tries > 20) {
        window.clearInterval(t);
      }
    }, 150);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLucide);
  } else {
    bootLucide();
  }
  window.RobustaIcons = { render: renderLucide };

  // Header: solid state on scroll (only relevant on home where header starts transparent)
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var threshold = 64;
    var ticking = false;
    function update() {
      ticking = false;
      if (window.scrollY > threshold) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // Altura da pilha do topo (faixa de avisos + cabeçalho).
  // finalizacao.js é a fonte de verdade (window.RobustaHeader.sync); aqui só
  // garantimos um valor inicial caso aquele script ainda não tenha carregado.
  function setStackHeight() {
    if (window.RobustaHeader && typeof window.RobustaHeader.sync === 'function') {
      window.RobustaHeader.sync();
      return;
    }
    var ann = document.querySelector('.announcement-bar');
    var stack = document.querySelector('[data-header-stack]');
    document.documentElement.style.setProperty('--ann-bar-h', (ann ? ann.offsetHeight : 0) + 'px');
    if (stack) document.documentElement.style.setProperty('--header-stack-h', stack.offsetHeight + 'px');
  }
  setStackHeight();
  window.addEventListener('resize', setStackHeight);

  // Mobile menu toggle (placeholder)
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var target = document.querySelector(toggle.getAttribute('data-menu-toggle'));
    if (!target) return;
    var open = target.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
  });

  // Product gallery thumbs
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-product-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-product-gallery]');
    if (!root) return;
    var main = root.querySelector('[data-product-main-image]');
    var src = thumb.getAttribute('data-src');
    if (main && src) main.src = src;
    root.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
    thumb.setAttribute('aria-current', 'true');
  });

  // ===== Product carousel =====
  function initProductCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var cards = track.querySelectorAll('.product-card-v2');
    if (!cards.length) return;

    function getStep() {
      var first = cards[0];
      var second = cards[1];
      if (!first) return 0;
      if (second) return second.offsetLeft - first.offsetLeft;
      return first.getBoundingClientRect().width + 24;
    }

    function updateButtons() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    // Dots — contagem baseada nos snap positions reais (maxScroll / step),
    // mesma lógica usada pelo carrossel de avaliações (initReviewsCarousel).
    var dots = [];

    function rebuildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];

      var step = getStep();
      if (!step) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;

      var numDots = Math.max(1, Math.round(maxScroll / step) + 1);

      for (var i = 0; i < numDots; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'product-carousel__dot';
        d.setAttribute('aria-label', 'Ir para slide ' + (i + 1));
        (function (idx) {
          d.addEventListener('click', function () {
            track.scrollTo({ left: idx * step, behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(d);
        dots.push(d);
      }
      updateDots();
    }

    function updateDots() {
      if (!dots.length) return;
      var step = getStep();
      var idx = step ? Math.round(track.scrollLeft / step) : 0;
      idx = Math.min(idx, dots.length - 1);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    // Tilt effect — cards lean based on scroll velocity
    var lastLeft = track.scrollLeft;
    var lastT = performance.now();
    var resetTimer;
    function onScroll() {
      var now = performance.now();
      var dx = track.scrollLeft - lastLeft;
      var dt = Math.max(1, now - lastT);
      var v = dx / dt; // px/ms
      var isMobile = window.innerWidth <= 768;
      var max = isMobile ? 4 : 7;
      var factor = isMobile ? -0.9 : -1.6;
      var tilt = Math.max(-max, Math.min(max, v * factor));
      cards.forEach(function (c) {
        c.style.transform = 'rotate(' + tilt.toFixed(2) + 'deg)';
      });
      lastLeft = track.scrollLeft;
      lastT = now;
      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () {
        cards.forEach(function (c) { c.style.transform = ''; });
      }, 140);
      updateDots();
      updateButtons();
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { rebuildDots(); updateButtons(); });
    requestAnimationFrame(function () {
      rebuildDots();
      updateButtons();
    });
  }

  document.querySelectorAll('[data-product-carousel]').forEach(initProductCarousel);

  // ── Product card: galeria de imagens no hover ──────────────
  // • Auto-cicla fotos a cada 1.4s no hover
  // • Bullets para navegar entre fotos (hover no bullet troca foto)
  // • "Adicione ao carrinho" label anima via CSS (max-width trick)
  // • Opacity dip suave ao trocar imagem
  function initProductCards(context) {
    var root = context || document;
    root.querySelectorAll('.product-card-v2').forEach(function(card) {
      var media = card.querySelector('.product-card-v2__media');
      if (!media) return;

      var raw = media.getAttribute('data-images') || '';
      var images = raw.split('|').map(function(s) { return s.trim(); }).filter(Boolean);
      if (images.length < 2) return;

      var currentIdx = 0;
      var timer      = null;
      var bulletsEl  = null;

      /* Cria os bullets */
      bulletsEl = document.createElement('div');
      bulletsEl.className = 'product-card-v2__bullets';
      bulletsEl.setAttribute('aria-hidden', 'true');
      images.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-card-v2__bullet' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('mouseenter', function() {
          clearInterval(timer);
          goTo(i);
        });
        dot.addEventListener('mouseleave', function() {
          /* retoma ciclo ao sair do bullet */
          startCycle();
        });
        bulletsEl.appendChild(dot);
      });
      media.appendChild(bulletsEl);

      /* Troca de imagem com opacity dip */
      function goTo(idx) {
        if (idx === currentIdx) return;
        media.style.opacity = '0.72';
        setTimeout(function() {
          currentIdx = idx;
          media.style.backgroundImage = "url('" + images[idx] + "')";
          media.style.opacity = '1';
          /* Atualiza bullet ativo */
          bulletsEl.querySelectorAll('.product-card-v2__bullet').forEach(function(b, bi) {
            b.classList.toggle('is-active', bi === idx);
          });
        }, 120);
      }

      function startCycle() {
        clearInterval(timer);
        timer = setInterval(function() {
          goTo((currentIdx + 1) % images.length);
        }, 1400);
      }

      card.addEventListener('mouseenter', function() {
        /* Pré-carrega todas as imagens */
        images.forEach(function(src) {
          var img = new Image(); img.src = src;
        });
        startCycle();
      });

      card.addEventListener('mouseleave', function() {
        clearInterval(timer);
        /* Volta para a primeira imagem */
        if (currentIdx !== 0) {
          media.style.opacity = '0.72';
          setTimeout(function() {
            currentIdx = 0;
            media.style.backgroundImage = "url('" + images[0] + "')";
            media.style.opacity = '1';
            bulletsEl.querySelectorAll('.product-card-v2__bullet').forEach(function(b, bi) {
              b.classList.toggle('is-active', bi === 0);
            });
          }, 120);
        }
      });

      /* Add to cart button */
      var addBtn = card.querySelector('.product-card-v2__add');
      if (addBtn) {
        addBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = addBtn.getAttribute('data-product-id');
          if (!variantId) return;
          addBtn.style.opacity = '0.5';
          addBtn.disabled = true;
          var fd = new FormData();
          fd.append('id', variantId);
          fd.append('quantity', '1');
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function(r) { return r.json(); })
            .then(function(item) {
              addBtn.style.opacity = '1';
              addBtn.disabled = false;
              showCartPopup(item);
            })
            .catch(function() {
              addBtn.style.opacity = '1';
              addBtn.disabled = false;
            });
        });
      }
    });
  }

  /* ── Cart Popup ─────────────────────────────── */

  /** Redimensiona uma imagem do CDN da Shopify sem quebrar a URL (?v=…) */
  function cdnImage(url, width) {
    if (!url) return '';
    if (/(^|\/)no-image/i.test(url)) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function showCartPopup(addedItem) {
    var overlay = document.querySelector('.cart-popup-overlay');
    var popup   = document.querySelector('.cart-popup');
    if (!overlay || !popup) return;

    /* Bloco "adicionado ao carrinho": só aparece quando veio de um add-to-cart.
       Sem isso o <img src=""> ficava com URL inválida e quebrava o layout. */
    var addedEl = popup.querySelector('[data-cart-added]');
    if (addedEl) {
      clearTimeout(addedEl._timer);
      if (addedItem) {
        var titleEl = popup.querySelector('.cart-popup__added-title');
        var nome = addedItem.product_title || addedItem.title || 'Produto';
        if (titleEl) titleEl.textContent = nome + ' adicionado ao carrinho';
        addedEl.removeAttribute('hidden');
        // A confirmação cumpriu o papel assim que foi lida; deixá-la fixa só
        // rouba altura de quem realmente importa, que é a lista de itens.
        addedEl._timer = setTimeout(function () {
          addedEl.setAttribute('hidden', 'hidden');
        }, 4000);
      } else {
        addedEl.setAttribute('hidden', 'hidden');
      }
    }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (window.RobustaCart && typeof window.RobustaCart.refresh === 'function') {
          window.RobustaCart.refresh(cart);
        } else {
          document.querySelectorAll('.site-header__cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          var subtotalEl = popup.querySelector('.cart-popup__subtotal-value');
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        }
      })
      .catch(function() {});

    overlay.classList.add('is-open');
    popup.classList.add('is-open');
    document.body.classList.add('has-cart-open');
  }

  window.RobustaCartImage = cdnImage;

  /* Exposto cedo para que finalizacao.js possa mesclar refresh/applyDiscount */
  window.RobustaCart = window.RobustaCart || {};
  window.RobustaCart.open = showCartPopup;

  function formatMoney(cents) {
    var val = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + val;
  }

  function initCartPopup() {
    /* Create popup HTML if not exists */
    if (document.querySelector('.cart-popup')) return;

    var overlayEl = document.createElement('div');
    overlayEl.className = 'cart-popup-overlay';

    var cfg = window.RobustaCartConfig || {};
    var infoSlides = (cfg.infoMessages && cfg.infoMessages.length) ? cfg.infoMessages : [
      'Nosso prazo de processamento do pedido é de até 1 dia útil após a confirmação do pagamento, mas a média é menos que isso.',
      'Nem a Robusta ou as transportadoras parceiras cobram valores extras para realizar a entrega do seu pedido, e também nunca solicitam fotos do seu documento pessoal. Em caso de suspeita de golpe, entre em contato conosco.'
    ];
    var infoIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="cart-info-carousel__icon"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>';

    var popupEl = document.createElement('div');
    popupEl.className = 'cart-popup';
    popupEl.setAttribute('role', 'dialog');
    popupEl.setAttribute('aria-label', 'Carrinho');
    popupEl.innerHTML =
      '<div class="cart-popup__head">' +
        '<h2 class="cart-popup__heading">Carrinho</h2>' +
        '<button type="button" class="cart-popup__close" aria-label="Fechar carrinho">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="cart-popup__info-carousel cart-info-carousel" data-info-carousel>' +
        '<div class="cart-info-carousel__track" data-info-carousel-track>' +
          infoSlides.map(function (txt, i) {
            return '<div class="cart-info-carousel__slide' + (i === 0 ? ' is-active' : '') + '">' +
              infoIcon + '<p>' + escapeHtml(txt) + '</p></div>';
          }).join('') +
        '</div>' +
      '</div>' +
      '<div class="cart-popup__shipping-bar" data-free-shipping-bar ' +
        'data-threshold="' + (cfg.freeShippingThreshold || 14990) + '" ' +
        'data-reached-text="' + escapeHtml(cfg.freeShippingReachedText || 'Você ganhou frete grátis!') + '"></div>' +
      /* Confirmação enxuta e passageira. Antes era um bloco fixo com foto de
         72px, título e preço — repetindo o item que já aparece na lista logo
         abaixo e comendo a altura dela. */
      '<div class="cart-popup__added" data-cart-added hidden role="status">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
        '<span class="cart-popup__added-title"></span>' +
      '</div>' +
      '<div class="cart-popup__items" data-cart-popup-items></div>' +
      '<div class="cart-popup__foot">' +
        /* ── Cupom de desconto ── */
        '<div class="cart-popup__discount cart-discount" data-discount-form>' +
          '<div class="cart-discount__row">' +
            '<input type="text" class="cart-discount__input" data-discount-input placeholder="Cupom de desconto" aria-label="Cupom de desconto" autocomplete="off">' +
            '<button type="button" class="cart-discount__btn" data-discount-apply>Aplicar</button>' +
          '</div>' +
          '<p class="cart-discount__message" data-discount-message hidden></p>' +
          '<ul class="cart-discount__applied" data-discount-applied hidden></ul>' +
        '</div>' +
        '<div class="cart-popup__subtotal">' +
          '<span class="cart-popup__subtotal-label">Subtotal</span>' +
          '<span class="cart-popup__subtotal-value" data-cart-popup-subtotal>R$ 0,00</span>' +
        '</div>' +
        '<div class="cart-popup__payment-appeals cart-payment-appeals" data-payment-appeals></div>' +
        '<div class="cart-popup__actions">' +
          '<a class="cart-popup__btn cart-popup__btn--primary" href="/checkout">Finalizar compra</a>' +
          '<a class="cart-popup__btn cart-popup__btn--secondary" href="/cart">Ver carrinho</a>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlayEl);
    document.body.appendChild(popupEl);

    if (window.RobustaIcons) window.RobustaIcons.render(popupEl);
    else renderLucide(popupEl);

    var closeBtn = popupEl.querySelector('.cart-popup__close');
    function closePopup() {
      overlayEl.classList.remove('is-open');
      popupEl.classList.remove('is-open');
      document.body.classList.remove('has-cart-open');
    }
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    overlayEl.addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popupEl.classList.contains('is-open')) closePopup();
    });
    window.RobustaCart = window.RobustaCart || {};
    window.RobustaCart.close = closePopup;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  window.RobustaEscape = escapeHtml;

  initProductCards();
  initCartPopup();

  // ── Produtos Relacionados — Shopify Recommendations API ──────
  function initRelatedProducts(section) {
    var sectionId = section.getAttribute('data-section-id');
    var productId = section.getAttribute('data-product-id');
    var limit     = section.getAttribute('data-limit') || 8;

    if (!sectionId || !productId) return;

    var url = '/recommendations/products?section_id=' + sectionId
            + '&product_id=' + productId
            + '&limit=' + limit;

    fetch(url)
      .then(function(r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function(html) {
        var doc     = new DOMParser().parseFromString(html, 'text/html');
        var fetched = doc.getElementById('related-products-' + sectionId);
        if (!fetched) return;

        // Substitui conteúdo mantendo o elemento raiz
        section.innerHTML = fetched.innerHTML;

        // Re-inicializa carousel, ícones Lucide e galeria de imagens
        var newCarousel = section.querySelector('[data-carousel-track]');
        if (newCarousel) initProductCarousel(section);
        renderLucide(section);
        initProductCards(section);
      })
      .catch(function() {
        // Sem recomendações ou erro: oculta a seção silenciosamente
        section.style.display = 'none';
      });
  }

  document.querySelectorAll('[data-related-section]').forEach(initRelatedProducts);

  // ===== Icon boxes: entrance animation (desktop) =====
  function initIconBoxes(root) {
    var boxes = root.querySelectorAll('.icon-box');
    if (!boxes.length) return;

    if (!('IntersectionObserver' in window)) {
      boxes.forEach(function (b) { b.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var boxes2 = entry.target.querySelectorAll('.icon-box');
        boxes2.forEach(function (b, i) {
          setTimeout(function () { b.classList.add('is-visible'); }, i * 130);
        });
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    observer.observe(root);
  }

  document.querySelectorAll('[data-icon-carousel]').forEach(initIconBoxes);

  // ===== As Linhas: entrance + mobile carousel =====
  function initLinesSection(root) {
    // Entrance animation (desktop)
    var cols = root.querySelectorAll('.lines-col');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.querySelectorAll('.lines-col').forEach(function (c, i) {
            setTimeout(function () { c.classList.add('is-visible'); }, i * 120);
          });
          obs.unobserve(e.target);
        });
      }, { threshold: 0.1 }).observe(root);
    } else {
      cols.forEach(function (c) { c.classList.add('is-visible'); });
    }

    // Mobile-only carousel
    if (window.innerWidth > 768) return;

    var viewport = root.querySelector('[data-lines-track]');
    if (!viewport) return;
    var trackEl = viewport.querySelector('.lines-section__track');
    if (!trackEl) return;

    var realItems = Array.from(trackEl.querySelectorAll('.lines-col'));
    var numReal = realItems.length;
    if (numReal < 2) return;

    var lastClone  = realItems[numReal - 1].cloneNode(true);
    var firstClone = realItems[0].cloneNode(true);
    [lastClone, firstClone].forEach(function (c) { c.setAttribute('aria-hidden', 'true'); });
    trackEl.insertBefore(lastClone, realItems[0]);
    trackEl.appendChild(firstClone);

    var allItems = Array.from(trackEl.querySelectorAll('.lines-col'));

    function scrollToItem(idx, smooth) {
      var item = allItems[idx];
      if (!item) return;
      var target = item.offsetLeft + item.offsetWidth / 2 - viewport.offsetWidth / 2;
      if (smooth) {
        viewport.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      } else {
        viewport.style.scrollSnapType = 'none';
        viewport.scrollLeft = Math.max(0, target);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { viewport.style.scrollSnapType = ''; });
        });
      }
    }

    function closestIdx() {
      var mid = viewport.scrollLeft + viewport.offsetWidth / 2;
      var best = 0, bestDist = Infinity;
      allItems.forEach(function (item, i) {
        var dist = Math.abs(item.offsetLeft + item.offsetWidth / 2 - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    requestAnimationFrame(function () { scrollToItem(1, false); });

    var wrapTimer;
    viewport.addEventListener('scroll', function () {
      clearTimeout(wrapTimer);
      wrapTimer = setTimeout(function () {
        var idx = closestIdx();
        if (idx === 0)                    { scrollToItem(numReal, false); }
        else if (idx >= allItems.length - 1) { scrollToItem(1, false); }
      }, 200);
    }, { passive: true });

    // Autoplay
    var autoTimer = null;
    function advance() { scrollToItem(closestIdx() + 1, true); }
    function startAutoplay() { if (!autoTimer) autoTimer = setInterval(advance, 3400); }
    function pauseAutoplay() { clearInterval(autoTimer); autoTimer = null; }

    root.addEventListener('mouseenter', pauseAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('touchstart', pauseAutoplay, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(startAutoplay, 2000); }, { passive: true });
    startAutoplay();
  }

  document.querySelectorAll('[data-lines-carousel]').forEach(initLinesSection);

  // ===== Icon boxes carousel infinito (mobile) + autoplay =====
  function initIconCarousel(root) {
    if (window.innerWidth > 768) return;

    var viewport = root.querySelector('[data-icon-track]');
    if (!viewport) return;
    var trackEl = viewport.querySelector('.icon-boxes__track');
    if (!trackEl) return;

    var realItems = Array.from(trackEl.querySelectorAll('.icon-box'));
    var numReal = realItems.length;
    if (numReal < 2) return;

    // Adiciona clones: último no início, primeiro no final
    var lastClone  = realItems[numReal - 1].cloneNode(true);
    var firstClone = realItems[0].cloneNode(true);
    [lastClone, firstClone].forEach(function(c){ c.setAttribute('aria-hidden','true'); });
    trackEl.insertBefore(lastClone, realItems[0]);
    trackEl.appendChild(firstClone);

    // allItems = [lastClone, real0..real(n-1), firstClone]
    var allItems = Array.from(trackEl.querySelectorAll('.icon-box'));
    var curIdx = 1; // começa no primeiro item real

    // Centraliza um item no viewport (sem ou com animação)
    function scrollToItem(idx, smooth) {
      var item = allItems[idx];
      if (!item) return;
      var center = item.offsetLeft + item.offsetWidth / 2;
      var target = center - viewport.offsetWidth / 2;
      if (smooth) {
        viewport.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      } else {
        viewport.style.scrollSnapType = 'none';
        viewport.scrollLeft = Math.max(0, target);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            viewport.style.scrollSnapType = '';
          });
        });
      }
    }

    // Índice do item cujo centro está mais próximo do centro do viewport
    function closestIdx() {
      var mid = viewport.scrollLeft + viewport.offsetWidth / 2;
      var best = 0, bestDist = Infinity;
      allItems.forEach(function (item, i) {
        var dist = Math.abs((item.offsetLeft + item.offsetWidth / 2) - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    // Inicia no item real 0 (índice 1 no array com clone)
    requestAnimationFrame(function () { scrollToItem(1, false); });

    // Wrap infinito: quando snap pousa num clone, salta silenciosamente
    var wrapTimer;
    viewport.addEventListener('scroll', function () {
      clearTimeout(wrapTimer);
      wrapTimer = setTimeout(function () {
        curIdx = closestIdx();
        if (curIdx === 0) {
          // Clone do último → pula para o real último
          scrollToItem(numReal, false);
          curIdx = numReal;
        } else if (curIdx === allItems.length - 1) {
          // Clone do primeiro → pula para o real primeiro
          scrollToItem(1, false);
          curIdx = 1;
        }
      }, 200);
    }, { passive: true });

    // Autoplay
    var autoTimer = null;

    function advance() {
      curIdx = closestIdx();
      var next = curIdx + 1; // deixa wrap handler cuidar do loop
      scrollToItem(next, true);
    }

    function startAutoplay() {
      if (autoTimer) return;
      autoTimer = setInterval(advance, 3200);
    }
    function pauseAutoplay() {
      clearInterval(autoTimer);
      autoTimer = null;
    }

    root.addEventListener('mouseenter', pauseAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('touchstart', pauseAutoplay, { passive: true });
    root.addEventListener('touchend', function () {
      setTimeout(startAutoplay, 2000);
    }, { passive: true });

    startAutoplay();
  }

  document.querySelectorAll('[data-icon-carousel]').forEach(initIconCarousel);

  // ===== Selos carousel (infinito — desktop e mobile) =====
  function initSelosCarousel(root) {
    var viewport = root.querySelector('[data-selos-track]');
    if (!viewport) return;
    var trackEl = viewport.querySelector('.selos-track');
    if (!trackEl) return;

    var realItems = Array.from(trackEl.querySelectorAll('.selos-card'));
    var numReal = realItems.length;
    if (numReal < 2) return;

    // Adiciona um conjunto completo de clones antes e depois dos itens reais:
    // [clone_0..n-1 | real_0..n-1 | clone_0..n-1]
    // Isso garante que sempre há conteúdo suficiente para center-snap em qualquer viewport.
    function addCloneSet(insertBefore) {
      var frag = document.createDocumentFragment();
      realItems.forEach(function (item) {
        var c = item.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        frag.appendChild(c);
      });
      if (insertBefore) trackEl.insertBefore(frag, realItems[0]);
      else trackEl.appendChild(frag);
    }
    addCloneSet(true);   // clones antes
    addCloneSet(false);  // clones depois

    var allItems = Array.from(trackEl.querySelectorAll('.selos-card'));
    // Itens reais: índices numReal … 2*numReal-1
    var curIdx = numReal;

    function scrollToItem(idx, smooth) {
      var item = allItems[idx];
      if (!item) return;
      var center = item.offsetLeft + item.offsetWidth / 2;
      var target = center - viewport.offsetWidth / 2;
      if (smooth) {
        viewport.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      } else {
        viewport.style.scrollSnapType = 'none';
        viewport.scrollLeft = Math.max(0, target);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { viewport.style.scrollSnapType = ''; });
        });
      }
    }

    function closestIdx() {
      var mid = viewport.scrollLeft + viewport.offsetWidth / 2;
      var best = 0, bestDist = Infinity;
      allItems.forEach(function (item, i) {
        var dist = Math.abs((item.offsetLeft + item.offsetWidth / 2) - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    requestAnimationFrame(function () { scrollToItem(numReal, false); });

    window.addEventListener('resize', function () {
      requestAnimationFrame(function () { scrollToItem(curIdx, false); });
    });

    // Wrap infinito: quando entra na zona de clones, salta silenciosamente para o real
    var wrapTimer;
    viewport.addEventListener('scroll', function () {
      clearTimeout(wrapTimer);
      wrapTimer = setTimeout(function () {
        curIdx = closestIdx();
        if (curIdx < numReal) {
          scrollToItem(curIdx + numReal, false);
          curIdx += numReal;
        } else if (curIdx >= 2 * numReal) {
          scrollToItem(curIdx - numReal, false);
          curIdx -= numReal;
        }
      }, 200);
    }, { passive: true });

    // Mouse drag (desktop)
    var isDragging = false, dragStartX = 0, dragScrollStart = 0;

    viewport.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragStartX = e.pageX;
      dragScrollStart = viewport.scrollLeft;
      viewport.style.scrollSnapType = 'none';
      viewport.classList.add('is-dragging');
      pauseAutoplay();
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      viewport.scrollLeft = dragScrollStart - (e.pageX - dragStartX);
    });

    window.addEventListener('mouseup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      viewport.style.scrollSnapType = '';
      if (Math.abs(e.pageX - dragStartX) > 5) {
        curIdx = closestIdx();
        scrollToItem(curIdx, true);
      }
      setTimeout(startAutoplay, 800);
    });

    // Autoplay
    var autoTimer = null;
    function advance() { curIdx = closestIdx(); scrollToItem(curIdx + 1, true); }
    function startAutoplay() { if (autoTimer) return; autoTimer = setInterval(advance, 3500); }
    function pauseAutoplay() { clearInterval(autoTimer); autoTimer = null; }

    root.addEventListener('mouseenter', pauseAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('touchstart', pauseAutoplay, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(startAutoplay, 2000); }, { passive: true });
    startAutoplay();
  }

  document.querySelectorAll('[data-selos-carousel]').forEach(initSelosCarousel);

  // ===== Reviews carousel =====
  function initReviewsCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var cards = track.querySelectorAll('.review-card');
    if (!cards.length) return;

    function getStep() {
      var first = cards[0], second = cards[1];
      if (!first) return 0;
      if (second) return second.offsetLeft - first.offsetLeft;
      return first.getBoundingClientRect().width + 16;
    }

    function updateButtons() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    // Dots — contagem baseada nos snap positions reais (maxScroll / step),
    // não 1:1 com cards. Assim no desktop com 4+ cards visíveis o número
    // de dots reflete apenas as posições alcançáveis.
    var dots = [];

    function rebuildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];

      var step = getStep();
      if (!step) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;

      // Quantos passos cabem de 0 até maxScroll
      var numDots = Math.max(1, Math.round(maxScroll / step) + 1);

      for (var i = 0; i < numDots; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'reviews__dot';
        d.setAttribute('aria-label', 'Avaliação ' + (i + 1));
        (function (idx) {
          d.addEventListener('click', function () {
            track.scrollTo({ left: idx * step, behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(d);
        dots.push(d);
      }
      updateDots();
    }

    function updateDots() {
      if (!dots.length) return;
      var step = getStep();
      var idx = step ? Math.round(track.scrollLeft / step) : 0;
      // Garante que o último dot fica ativo quando no fim do scroll
      idx = Math.min(idx, dots.length - 1);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    track.addEventListener('scroll', function () {
      updateDots();
      updateButtons();
    }, { passive: true });

    // Reconstrói dots no resize (muda quantidade de cards visíveis)
    window.addEventListener('resize', function () {
      rebuildDots();
      updateButtons();
    });

    // Aguarda layout para medir offsetLeft e scrollWidth corretamente
    requestAnimationFrame(function () {
      rebuildDots();
      updateButtons();
    });
  }

  document.querySelectorAll('[data-reviews-carousel]').forEach(initReviewsCarousel);

  // ── Footer entrance animations ─────────────────────────────────────────
  function initFooter(root) {
    var animEls = root.querySelectorAll('[data-footer-anim]');
    if (!animEls.length) return;

    // No Shopify editor (design mode) → mostrar tudo imediatamente, sem animação
    if (window.Shopify && window.Shopify.designMode) {
      animEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    // Aplicar classe hidden (opacity:0 + translateY) apenas quando JS está ativo
    animEls.forEach(function (el, i) {
      el.classList.add('footer-anim--hidden');
      el.style.transitionDelay = (i * 0.10) + 's';
    });

    if (!('IntersectionObserver' in window)) {
      animEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('footer-anim--hidden');
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.10, rootMargin: '0px 0px -32px 0px' });

    animEls.forEach(function (el) { observer.observe(el); });
  }

  document.querySelectorAll('[data-footer]').forEach(initFooter);

  // ── Product Page ────────────────────────────────────────────
  function initProductPage(root) {
    if (!root) return;

    // ── Galeria: foto, GIF animado e vídeo ────────────────────────────
    var thumbs   = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-src]'));
    var mainImg  = root.querySelector('[data-gallery-main]');
    var videoBox = root.querySelector('[data-gallery-video-stage]');

    function clearVideo() {
      if (!videoBox) return;
      videoBox.innerHTML = '';
      videoBox.setAttribute('hidden', 'hidden');
      if (mainImg) mainImg.removeAttribute('hidden');
    }

    function showThumb(thumb, autoplay) {
      if (!thumb) return;
      var type = thumb.getAttribute('data-gallery-type') || 'image';
      var src  = thumb.getAttribute('data-gallery-src');
      var alt  = thumb.getAttribute('data-gallery-alt') || '';

      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });

      if (type === 'video' && videoBox) {
        var url = thumb.getAttribute('data-gallery-video');
        if (url) {
          videoBox.innerHTML = '<video controls playsinline preload="metadata" ' +
            (autoplay ? 'autoplay muted ' : '') +
            'poster="' + (src || '') + '"><source src="' + url + '"></video>';
          videoBox.removeAttribute('hidden');
          if (mainImg) mainImg.setAttribute('hidden', 'hidden');
          return;
        }
      }

      if (type === 'external_video' && videoBox) {
        var id = thumb.getAttribute('data-gallery-embed');
        var host = (thumb.getAttribute('data-gallery-host') || 'youtube').toLowerCase();
        if (id) {
          var embed = host.indexOf('vimeo') !== -1
            ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
            : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
          videoBox.innerHTML = '<iframe src="' + embed + '" title="Vídeo do produto" frameborder="0" ' +
            'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
          videoBox.removeAttribute('hidden');
          if (mainImg) mainImg.setAttribute('hidden', 'hidden');
          return;
        }
      }

      clearVideo();
      if (mainImg && src) {
        mainImg.classList.add('is-fading');
        setTimeout(function () {
          mainImg.src = src;
          if (alt) mainImg.alt = alt;
          mainImg.classList.remove('is-fading');
        }, 180);
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showThumb(thumb, true); });
    });

    /** Mostra a mídia de um índice da galeria (usado ao trocar de variante) */
    function showMediaIndex(idx) {
      if (idx === null || idx === undefined || idx < 0) return false;
      for (var i = 0; i < thumbs.length; i++) {
        if (parseInt(thumbs[i].getAttribute('data-media-index'), 10) === idx) {
          showThumb(thumbs[i], false);
          thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          return true;
        }
      }
      return false;
    }

    // Variants — pill selection + variant ID update
    var sid = root.getAttribute('data-section-id') || '';
    var variantsJson = document.getElementById('product-variants-' + sid);
    if (!variantsJson) {
      // fallback: qualquer script de variantes dentro da página
      variantsJson = root.querySelector('script[id^="product-variants-"]') ||
        document.querySelector('script[id^="product-variants-"]');
    }
    var variants = [];
    try { if (variantsJson) variants = JSON.parse(variantsJson.textContent); } catch (e) {}

    function moneyBR(cents) {
      return 'R$ ' + (Number(cents) / 100).toFixed(2).replace('.', ',');
    }

    function currentSelectedOptions() {
      var selected = [];
      root.querySelectorAll('.product-variants-group').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-idx'), 10);
        var active = group.querySelector('.product-variant.is-active');
        if (active) selected[idx] = active.getAttribute('data-option-val');
      });
      return selected;
    }

    function findVariant(selected) {
      if (!variants.length) return null;
      return variants.find(function (v) {
        var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        if (!opts.length) return false;
        return opts.every(function (opt, i) { return selected[i] === opt; });
      }) || null;
    }

    // Mapa variante → índice da mídia na galeria (gerado no liquid)
    var variantMedia = {};
    var mediaJson = document.getElementById('product-variant-media-' + sid) ||
      root.querySelector('script[id^="product-variant-media-"]') ||
      document.querySelector('script[id^="product-variant-media-"]');
    try { if (mediaJson) variantMedia = JSON.parse(mediaJson.textContent) || {}; } catch (e) { variantMedia = {}; }

    function applyVariant(match) {
      if (!match) return;
      var idInput     = root.querySelector('[data-variant-id]');
      var priceEl     = root.querySelector('[data-price]');
      var compareEl   = root.querySelector('[data-compare-price]');
      var badgeEl     = root.querySelector('[data-discount-badge]');
      var stickyPrice = root.querySelector('[data-sticky-price]');
      var atcBtn      = root.querySelector('[data-atc-btn]');
      var atcText     = root.querySelector('[data-atc-text]');

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = moneyBR(match.price);
      if (stickyPrice) stickyPrice.textContent = moneyBR(match.price);

      var stickyCompare = root.querySelector('[data-sticky-compare]');
      if (stickyCompare) {
        var emPromo = !!(match.compare_at_price && match.compare_at_price > match.price);
        stickyCompare.textContent = emPromo ? moneyBR(match.compare_at_price) : '';
        stickyCompare.hidden = !emPromo;
      }

      var onSale = !!(match.compare_at_price && match.compare_at_price > match.price);
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = moneyBR(match.compare_at_price);
          compareEl.hidden = false;
          compareEl.style.display = '';
        } else {
          compareEl.hidden = true;
          compareEl.style.display = 'none';
        }
      }
      if (badgeEl) {
        if (onSale) {
          var pct = Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100);
          badgeEl.textContent = '-' + pct + '%';
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
          badgeEl.textContent = '';
        }
      }

      // Disponibilidade
      if (atcBtn) {
        atcBtn.disabled = match.available === false;
        if (atcText) atcText.textContent = match.available === false ? 'ESGOTADO' : 'ADICIONAR AO CARRINHO';
      }

      // Foto da galeria correspondente à variante
      if (Object.prototype.hasOwnProperty.call(variantMedia, String(match.id))) {
        showMediaIndex(variantMedia[String(match.id)]);
      }

      // Atualiza URL sem recarregar (útil para compartilhar variante)
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    root.querySelectorAll('.product-variant').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(btn.getAttribute('data-option-idx'), 10);
        root.querySelectorAll('.product-variant[data-option-idx="' + idx + '"]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        applyVariant(findVariant(currentSelectedOptions()));
      });
    });

    // Sync inicial
    applyVariant(findVariant(currentSelectedOptions()) || variants[0] || null);

    // O contador de urgência de postagem é responsabilidade exclusiva do
    // finalizacao.js (RobustaPDP). Havia aqui um fallback que criava um
    // SEGUNDO setInterval sobre o mesmo elemento — os dois escreviam no
    // mesmo nó a cada segundo e o contador "piscava" entre dois valores.

    // Quantity stepper
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var stepper = btn.closest('[data-qty]');
      if (!stepper) return;
      var input = stepper.querySelector('[data-form-qty]');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      input.value = next;
    });

    // Delivery accordion
    var deliveryToggle = root.querySelector('[data-delivery-toggle]');
    var deliveryBody   = root.querySelector('[data-delivery-body]');
    if (deliveryToggle && deliveryBody) {
      deliveryToggle.addEventListener('click', function () {
        var expanded = deliveryToggle.getAttribute('aria-expanded') === 'true';
        deliveryToggle.setAttribute('aria-expanded', String(!expanded));
        if (expanded) {
          deliveryBody.setAttribute('hidden', '');
        } else {
          deliveryBody.removeAttribute('hidden');
        }
      });
    }

    // Wishlist toggle — persists via localStorage
    var wishlistBtn = root.querySelector('[data-wishlist]');
    if (wishlistBtn) {
      var wKey = 'wl-' + (root.getAttribute('data-product-handle') || window.location.pathname);
      if (localStorage.getItem(wKey) === '1') wishlistBtn.classList.add('is-active');
      wishlistBtn.addEventListener('click', function () {
        var active = wishlistBtn.classList.toggle('is-active');
        try { localStorage.setItem(wKey, active ? '1' : '0'); } catch(e) {}
        if (active) {
          var toast = document.createElement('div');
          toast.className = 'product-toast';
          toast.textContent = 'Adicionado aos favoritos ✓';
          document.body.appendChild(toast);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { toast.classList.add('is-visible'); });
          });
          setTimeout(function () {
            toast.classList.remove('is-visible');
            setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
          }, 2500);
        }
      });
    }

    // AJAX Add to Cart
    var form = root.querySelector('[data-product-form]');
    var atcBtn  = root.querySelector('[data-atc-btn]');
    var atcText = root.querySelector('[data-atc-text]');
    if (form && atcBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        atcBtn.disabled = true;
        if (atcText) atcText.textContent = 'Adicionando...';
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            if (atcText) atcText.textContent = 'Adicionado ✓';
            showCartPopup(item);
            setTimeout(function () {
              if (atcText) atcText.textContent = 'ADICIONAR AO CARRINHO';
              atcBtn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            if (atcText) atcText.textContent = 'Erro. Tente novamente';
            atcBtn.disabled = false;
          });
      });
    }

    // ── Estimativa de entrega ────────────────────────────────────────
    // 1) Prazo base calculado pela região do cliente (IP) + tempo de preparo.
    // 2) Se o carrinho tiver itens, tenta o cálculo real da Shopify para
    //    substituir o prazo e mostrar o nome da transportadora.
    (function initDeliveryEstimate() {
      var cityEl    = root.querySelector('[data-delivery-city]');
      var stateEl   = root.querySelector('[data-delivery-state]');
      var dateEl    = root.querySelector('[data-delivery-date]');
      var carrierEl = root.querySelector('[data-delivery-carrier]');
      if (!dateEl) return;

      var MONTHS = ['janeiro','fevereiro','março','abril','maio','junho',
                    'julho','agosto','setembro','outubro','novembro','dezembro'];

      var REGION_BY_UF = {
        AC:'N', AP:'N', AM:'N', PA:'N', RO:'N', RR:'N', TO:'N',
        AL:'NE', BA:'NE', CE:'NE', MA:'NE', PB:'NE', PE:'NE', PI:'NE', RN:'NE', SE:'NE',
        DF:'CO', GO:'CO', MT:'CO', MS:'CO',
        ES:'SE', MG:'SE', RJ:'SE', SP:'SE',
        PR:'S', RS:'S', SC:'S'
      };

      function intAttr(name, fallback) {
        var v = parseInt(root.getAttribute(name), 10);
        return isNaN(v) ? fallback : v;
      }

      var handling = intAttr('data-handling-days', 1);
      var TRANSIT = {
        SE: intAttr('data-days-se', 3),
        S:  intAttr('data-days-s', 4),
        CO: intAttr('data-days-co', 5),
        NE: intAttr('data-days-ne', 7),
        N:  intAttr('data-days-n', 9)
      };

      /** Hora atual em Brasília (para saber se já passou do corte das 9h) */
      function brtHour() {
        try {
          return parseInt(new Intl.DateTimeFormat('pt-BR', {
            timeZone: 'America/Sao_Paulo', hour: '2-digit', hour12: false
          }).format(new Date()), 10);
        } catch (e) { return new Date().getHours(); }
      }

      function addBusinessDays(from, days) {
        var d = new Date(from.getTime());
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          var dow = d.getDay();
          if (dow !== 0 && dow !== 6) added++;
        }
        return d;
      }

      function formatRange(a, b) {
        if (a.getMonth() === b.getMonth()) {
          return a.getDate() + ' – ' + b.getDate() + ' de ' + MONTHS[b.getMonth()];
        }
        return a.getDate() + ' de ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' de ' + MONTHS[b.getMonth()];
      }

      function renderEstimate(uf) {
        var region  = REGION_BY_UF[(uf || '').toUpperCase()] || 'SE';
        var transit = TRANSIT[region] || TRANSIT.SE;
        var offset  = handling + (brtHour() >= 9 ? 1 : 0);
        var minDays = Math.max(1, transit - 2);
        var start = addBusinessDays(new Date(), offset + minDays);
        var end   = addBusinessDays(new Date(), offset + transit);
        dateEl.textContent = formatRange(start, end);
        if (carrierEl) {
          var name = root.getAttribute('data-carrier-name');
          if (name) {
            carrierEl.textContent = name;
            carrierEl.removeAttribute('hidden');
          }
        }
      }

      /** Cálculo real da Shopify — só funciona com itens no carrinho */
      function tryRealRates(zip, province) {
        if (!zip) return;
        var qs = 'shipping_address[zip]=' + encodeURIComponent(zip) +
                 '&shipping_address[country]=Brazil' +
                 (province ? '&shipping_address[province]=' + encodeURIComponent(province) : '');
        fetch('/cart/shipping_rates.json?' + qs, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function (data) {
            var rates = (data && data.shipping_rates) || [];
            if (!rates.length) return;
            var rate = rates[0];
            if (rate.delivery_date || rate.delivery_range) {
              var range = rate.delivery_range || [rate.delivery_date, rate.delivery_date];
              var a = new Date(range[0]);
              var b = new Date(range[range.length - 1]);
              if (!isNaN(a) && !isNaN(b)) dateEl.textContent = formatRange(a, b);
            }
            if (carrierEl && rate.name) {
              carrierEl.textContent = rate.name;
              carrierEl.removeAttribute('hidden');
            }
          })
          .catch(function () { /* carrinho vazio ou frete não configurado: mantém a estimativa */ });
      }

      var noteEl = root.querySelector('[data-delivery-note]');

      function setLocation(city, uf, precise) {
        if (city && cityEl) cityEl.textContent = city;
        if (uf && stateEl) stateEl.textContent = uf;
        renderEstimate(uf);
        if (noteEl) {
          noteEl.textContent = precise
            ? 'Prazo estimado para o CEP informado'
            : 'Frete estimado para a região aproximada';
        }
      }

      /* ── CEP salvo tem prioridade sobre o IP ── */
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem('robusta_cep') || 'null'); } catch (e) {}

      // Estimativa imediata pelo padrão da seção, antes de qualquer resposta
      renderEstimate(stateEl ? stateEl.textContent : 'SP');

      if (saved && saved.uf) {
        setLocation(saved.city, saved.uf, true);
        tryRealRates(saved.cep, saved.uf);
      } else {
        // A geolocalização por IP é só um palpite inicial — costuma errar a
        // cidade (devolve a do provedor). Por isso a nota diz "região aproximada"
        // e o campo de CEP fica disponível logo abaixo.
        fetch('https://ipapi.co/json/')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || !d.region_code) return;
            setLocation(d.city, d.region_code, false);
            tryRealRates(d.postal, d.region_code);
          })
          .catch(function () {});
      }

      /* ── Cálculo por CEP (ViaCEP) ──
         Sem <form>: este bloco está dentro do formulário de compra, e um
         formulário aninhado é descartado pelo navegador — era isso que fazia
         o botão de calcular adicionar o produto ao carrinho. A consulta
         dispara pelo Enter e ao sair do campo. */
      var cepBox    = root.querySelector('[data-cep-box]');
      var cepToggle = root.querySelector('[data-cep-toggle]');
      var cepInput  = root.querySelector('[data-cep-input]');
      var cepMsg    = root.querySelector('[data-cep-msg]');

      function showCepMsg(text, state) {
        if (!cepMsg) return;
        cepMsg.textContent = text;
        cepMsg.setAttribute('data-state', state);
        cepMsg.removeAttribute('hidden');
      }

      if (cepInput) {
        if (saved && saved.cep) cepInput.value = saved.cep;
        cepInput.addEventListener('input', function () {
          var v = cepInput.value.replace(/\D/g, '').slice(0, 8);
          cepInput.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
        });
      }

      if (cepToggle) {
        cepToggle.addEventListener('click', function () {
          var aberto = !cepBox.hasAttribute('hidden');
          if (aberto) {
            cepBox.setAttribute('hidden', '');
          } else {
            cepBox.removeAttribute('hidden');
            if (cepInput) cepInput.focus();
          }
          cepToggle.setAttribute('aria-expanded', String(!aberto));
        });
      }

      // Quem já informou o CEP antes não deve ter que abrir de novo.
      if (saved && saved.cep && cepBox) {
        cepBox.removeAttribute('hidden');
        if (cepToggle) cepToggle.setAttribute('aria-expanded', 'true');
      }

      function consultarCep() {
          var cep = (cepInput ? cepInput.value : '').replace(/\D/g, '');
          if (cep.length !== 8) {
            showCepMsg('Digite os 8 dígitos do CEP.', 'error');
            return;
          }
          showCepMsg('Consultando…', 'loading');
          fetch('https://viacep.com.br/ws/' + cep + '/json/')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (!d || d.erro) {
                showCepMsg('CEP não encontrado.', 'error');
                return;
              }
              setLocation(d.localidade, d.uf, true);
              tryRealRates(cep, d.uf);
              try {
                localStorage.setItem('robusta_cep', JSON.stringify({
                  cep: cepInput ? cepInput.value : cep, city: d.localidade, uf: d.uf
                }));
              } catch (err) {}
              showCepMsg(d.localidade + ' - ' + d.uf, 'success');
            })
            .catch(function () {
              showCepMsg('Não foi possível consultar o CEP agora.', 'error');
            });
      }

      if (cepInput) {
        cepInput.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          // Sem isso o Enter borbulha para o formulário de compra e o produto
          // vai para o carrinho no lugar de o frete ser calculado.
          e.preventDefault();
          e.stopPropagation();
          consultarCep();
        });
        // Quem digita e clica fora também espera ver o resultado.
        cepInput.addEventListener('blur', function () {
          if (cepInput.value.replace(/\D/g, '').length === 8) consultarCep();
        });
      }
    })();
  }

  var productPageEl = document.querySelector('[data-product-page]');
  if (productPageEl) {
    // pass section id for variants JSON
    var sectionEl = productPageEl.closest('[id^="shopify-section"]');
    if (sectionEl) {
      var sid = sectionEl.id.replace('shopify-section-', '');
      productPageEl.setAttribute('data-section-id', sid);
    }
    initProductPage(productPageEl);
  }

  // Benefits Section — IntersectionObserver entrance animations
  function initBenefitsSection(root) {
    if (!root) return;
    var els = root.querySelectorAll('[data-benefits-anim]');
    if (!els.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.1) + 's';
      observer.observe(el);
    });
  }
  document.querySelectorAll('[data-benefits-section]').forEach(initBenefitsSection);

  // How To Use — entrance animations (sections 1 and 2 share same observer)
  function initHowToSection(root) {
    if (!root) return;
    var els = root.querySelectorAll('[data-howto-anim]');
    if (!els.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.1) + 's';
      observer.observe(el);
    });
  }
  document.querySelectorAll('[data-howto-section], [data-howto-steps-section]').forEach(initHowToSection);

  // ── Details section ──────────────────────────────────────────
  // viewBox JS-calculado = círculos sempre circulares em qualquer width
  // ─────────────────────────────────────────────────────────────

  var EASE = 'cubic-bezier(0.4,0,0.2,1)';

  /* Constrói/atualiza o SVG desktop com geometria exata baseada no size real */
  function buildDesktopSVG(section) {
    var svg = section.querySelector('.details-svg--desktop');
    if (!svg) return;

    var W  = section.offsetWidth;
    var H  = section.offsetHeight;   // 700 px fixo no CSS
    var cx = W / 2, cy = H / 2;

    // Raio: proporcional à menor dimensão (≈262 em 1200×700)
    var R  = Math.round(Math.min(W * 0.218, H * 0.374));
    var Ri = Math.round(R * 0.706);   // círculo inner ≈ 185 em 262
    var Rh = Math.round(R * 0.744);   // halo fill   ≈ 195 em 262

    // Bullets a 45°
    var off = Math.round(R * 0.7071);
    var tlX = cx - off, tlY = cy - off;
    var trX = cx + off, trY = cy - off;
    var blX = cx - off, blY = cy + off;
    var brX = cx + off, brY = cy + off;

    // Extensão diagonal 40px/eixo
    var D = 40;
    var tlCx = tlX - D, tlCy = tlY - D;
    var trCx = trX + D, trCy = trY - D;
    var blCx = blX - D, blCy = blY + D;
    var brCx = brX + D, brCy = brY + D;

    /* Endpoints horizontais.

       Antes iam até 14px da borda, o que deixava linha e texto colados no
       canto enquanto o resto do site respira bem mais. Agora usam o mesmo
       recuo de `.page-width`: metade da tela menos metade da largura máxima
       de conteúdo (1440px), com mínimo de 32px. Em 1440 dá 32px, em 1920 dá
       272px, que é exatamente onde o texto do site começa.

       Como a linha e o texto partem do MESMO valor, os dois continuam
       alinhados em qualquer largura. */
    var pad = Math.max(32, Math.round(W / 2 - 688));
    var lL = pad, lR = W - pad;
    var lTop = tlCy, lBot = blCy;

    // Comprimento de cada linha (diagonal + horizontal)
    var diagLen  = Math.sqrt(D * D * 2);
    var horizLen = Math.max(tlCx - lL, lR - trCx);
    var lineLen  = Math.ceil(diagLen + horizLen) + 30;
    var outerC   = Math.ceil(2 * Math.PI * R)  + 20;
    var innerC   = Math.ceil(2 * Math.PI * Ri) + 20;

    var uid = section.getAttribute('data-uid') || 'ds0';
    var already = section.classList.contains('anim-go');

    // stroke-dashoffset inicial: 0 se já animou (resize), comprimento se ainda não
    var dOuter = already ? 0 : outerC;
    var dInner = already ? 0 : innerC;
    var dLine  = already ? 0 : lineLen;
    var bOpa   = already ? 0.92 : 0;

    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);

    svg.innerHTML =
      '<defs>' +
        '<radialGradient id="dg-h-' + uid + '" cx="50%" cy="50%" r="50%">' +
          '<stop offset="0%"   stop-color="#fff" stop-opacity="0.20"/>' +
          '<stop offset="55%"  stop-color="#fff" stop-opacity="0.05"/>' +
          '<stop offset="100%" stop-color="#fff" stop-opacity="0"/>' +
        '</radialGradient>' +
        '<linearGradient id="dg-i-' + uid + '" x1="0.5" y1="0" x2="0.5" y2="1">' +
          '<stop offset="0%"   stop-color="#fff" stop-opacity="0.55"/>' +
          '<stop offset="55%"  stop-color="#fff" stop-opacity="0.18"/>' +
          '<stop offset="100%" stop-color="#fff" stop-opacity="0"/>' +
        '</linearGradient>' +
      '</defs>' +
      // Halo
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + Rh + '" fill="url(#dg-h-' + uid + ')"/>' +
      // Outer circle
      '<circle data-dco cx="' + cx + '" cy="' + cy + '" r="' + R + '" fill="none" stroke="rgba(255,255,255,0.28)" stroke-width="1.5" style="stroke-dasharray:' + outerC + ';stroke-dashoffset:' + dOuter + '"/>' +
      // Inner circle (gradient stroke)
      '<circle data-dci cx="' + cx + '" cy="' + cy + '" r="' + Ri + '" fill="none" stroke="url(#dg-i-' + uid + ')" stroke-width="1.2" style="stroke-dasharray:' + innerC + ';stroke-dashoffset:' + dInner + '"/>' +
      // Lines
      '<polyline data-dtl points="' + tlX + ',' + tlY + ' ' + tlCx + ',' + tlCy + ' ' + lL + ',' + lTop + '" fill="none" stroke="rgba(255,255,255,0.42)" stroke-width="1" style="stroke-dasharray:' + lineLen + ';stroke-dashoffset:' + dLine + '"/>' +
      '<polyline data-dtr points="' + trX + ',' + trY + ' ' + trCx + ',' + trCy + ' ' + lR  + ',' + lTop + '" fill="none" stroke="rgba(255,255,255,0.42)" stroke-width="1" style="stroke-dasharray:' + lineLen + ';stroke-dashoffset:' + dLine + '"/>' +
      '<polyline data-dbl points="' + blX + ',' + blY + ' ' + blCx + ',' + blCy + ' ' + lL  + ',' + lBot + '" fill="none" stroke="rgba(255,255,255,0.42)" stroke-width="1" style="stroke-dasharray:' + lineLen + ';stroke-dashoffset:' + dLine + '"/>' +
      '<polyline data-dbr points="' + brX + ',' + brY + ' ' + brCx + ',' + brCy + ' ' + lR  + ',' + lBot + '" fill="none" stroke="rgba(255,255,255,0.42)" stroke-width="1" style="stroke-dasharray:' + lineLen + ';stroke-dashoffset:' + dLine + '"/>' +
      // Bullets
      '<circle data-dbu cx="' + tlX + '" cy="' + tlY + '" r="5.5" fill="#fff" opacity="' + bOpa + '"/>' +
      '<circle data-dbu cx="' + trX + '" cy="' + trY + '" r="5.5" fill="#fff" opacity="' + bOpa + '"/>' +
      '<circle data-dbu cx="' + blX + '" cy="' + blY + '" r="5.5" fill="#fff" opacity="' + bOpa + '"/>' +
      '<circle data-dbu cx="' + brX + '" cy="' + brY + '" r="5.5" fill="#fff" opacity="' + bOpa + '"/>';

    /* Largura do texto.

       Dois limites, vale o menor:
         1. parar antes do ponto onde a diagonal começa (tlX)
         2. parar antes da borda do círculo central (cx - R)

       O segundo é o que faltava: sem ele, em telas largas o parágrafo
       avançava por cima do círculo e do frasco. */
    var maxW = Math.round(Math.min(tlX - lL - 16, (cx - R) - lL - 24));
    var calloutCfg = [
      { sel: '.details-callout--tl', top: lTop + 13,     left: lL },
      { sel: '.details-callout--tr', top: lTop + 13,     right: W - lR },
      { sel: '.details-callout--bl', bottom: H - lBot + 13, left: lL },
      { sel: '.details-callout--br', bottom: H - lBot + 13, right: W - lR }
    ];
    calloutCfg.forEach(function(cfg) {
      var el = section.querySelector(cfg.sel);
      if (!el) return;
      el.style.maxWidth = maxW + 'px';
      if (cfg.top    !== undefined) el.style.top    = cfg.top    + 'px';
      if (cfg.bottom !== undefined) el.style.bottom = cfg.bottom + 'px';
      if (cfg.left   !== undefined) el.style.left   = cfg.left   + 'px';
      if (cfg.right  !== undefined) el.style.right  = cfg.right  + 'px';
    });
  }

  /* Dispara animação draw-on nos elementos SVG do desktop */
  function animateDesktopSVG(section) {
    var svg = section.querySelector('.details-svg--desktop');
    if (!svg) return;

    function trans(el, dur, delay, prop, val) {
      if (!el) return;
      el.style.transition = prop + ' ' + dur + 's ' + EASE + ' ' + delay + 's';
      // double rAF garante que o estado inicial foi pintado antes de transicionar
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          el.style[prop === 'stroke-dashoffset' ? 'strokeDashoffset' : prop] = val;
        });
      });
    }

    trans(svg.querySelector('[data-dco]'),  1.5,  0.0,  'stroke-dashoffset', '0');
    trans(svg.querySelector('[data-dci]'),  1.3,  0.2,  'stroke-dashoffset', '0');

    var delays = [0.55, 0.70, 0.85, 1.00];
    svg.querySelectorAll('[data-dtl],[data-dtr],[data-dbl],[data-dbr]').forEach(function(el, i) {
      trans(el, 0.85, delays[i] || 0.55, 'stroke-dashoffset', '0');
    });

    svg.querySelectorAll('[data-dbu]').forEach(function(el) {
      trans(el, 0.45, 1.15, 'opacity', '0.92');
    });
  }

  /* Mobile: spine vertical + circle + branches — linha horizontal toca a borda do círculo */
  function drawMobileDetailsSVG(section) {
    var svg = section.querySelector('.details-svg--mobile');
    if (!svg) return;

    var sW = section.offsetWidth;
    var sH = section.scrollHeight || section.offsetHeight;
    var cx = sW / 2;
    var spX = 24;   // x do spine
    var brL = 22;   // comprimento branch horizontal

    var imgWrap    = section.querySelector('.details-img-wrap');
    var productTop = imgWrap ? imgWrap.offsetTop : sH - 380;
    var imgH       = imgWrap ? imgWrap.offsetHeight : 380;

    // Círculo centrado verticalmente sobre a imagem
    var circR  = Math.round(Math.min(sW * 0.38, 155));
    var circCY = Math.round(productTop + imgH * 0.46);

    var uid = section.getAttribute('data-uid') || 'mob';

    var order    = ['tl', 'tr', 'bl', 'br'];
    var callouts = order.map(function(p) {
      return section.querySelector('.details-callout--' + p);
    }).filter(Boolean);

    var spineTop = callouts.length ? callouts[0].offsetTop + 14 : 40;
    // Spine termina no fim do parágrafo do último callout (não desce até o círculo)
    var lastCallout = callouts.length ? callouts[callouts.length - 1] : null;
    var spineBtm = lastCallout
      ? lastCallout.offsetTop + lastCallout.offsetHeight
      : circCY;

    var h = '<defs>' +
      '<radialGradient id="mh-' + uid + '" cx="50%" cy="50%" r="50%">' +
        '<stop offset="0%" stop-color="#fff" stop-opacity="0.18"/>' +
        '<stop offset="100%" stop-color="#fff" stop-opacity="0"/>' +
      '</radialGradient>' +
      '<linearGradient id="mi-' + uid + '" x1="0.5" y1="0" x2="0.5" y2="1">' +
        '<stop offset="0%" stop-color="#fff" stop-opacity="0.50"/>' +
        '<stop offset="65%" stop-color="#fff" stop-opacity="0.12"/>' +
        '<stop offset="100%" stop-color="#fff" stop-opacity="0"/>' +
      '</linearGradient>' +
      // Gradiente da spine: opaco no topo, transparente no fim
      '<linearGradient id="ms-' + uid + '" x1="0" y1="' + spineTop + '" x2="0" y2="' + spineBtm + '" gradientUnits="userSpaceOnUse">' +
        '<stop offset="0%"   stop-color="#fff" stop-opacity="0.30"/>' +
        '<stop offset="100%" stop-color="#fff" stop-opacity="0"/>' +
      '</linearGradient>' +
    '</defs>';

    // Halo + outer circle + inner circle (fade stroke)
    h += '<circle cx="' + cx + '" cy="' + circCY + '" r="' + Math.round(circR * 0.72) + '" fill="url(#mh-' + uid + ')"/>';
    h += '<circle cx="' + cx + '" cy="' + circCY + '" r="' + circR + '" fill="none" stroke="rgba(255,255,255,0.22)" stroke-width="1"/>';
    h += '<circle cx="' + cx + '" cy="' + circCY + '" r="' + Math.round(circR * 0.68) + '" fill="none" stroke="url(#mi-' + uid + ')" stroke-width="1.1"/>';

    // Spine vertical com fade: começa no primeiro callout, termina no último parágrafo
    h += '<line x1="' + spX + '" y1="' + spineTop + '" x2="' + spX + '" y2="' + spineBtm + '" stroke="url(#ms-' + uid + ')" stroke-width="1"/>';

    // Branches + bullets para cada callout
    callouts.forEach(function(callout) {
      var by = callout.offsetTop + 14;
      h += '<line x1="' + spX + '" y1="' + by + '" x2="' + (spX + brL) + '" y2="' + by + '" stroke="rgba(255,255,255,0.30)" stroke-width="1"/>';
      h += '<circle cx="' + spX + '" cy="' + by + '" r="3" fill="#fff" fill-opacity="0.78"/>';
    });

    svg.setAttribute('viewBox', '0 0 ' + sW + ' ' + sH);
    svg.style.height = sH + 'px';
    svg.innerHTML = h;
  }

  function initDetailsSection(root) {
    var isMobile = function() { return window.innerWidth <= 768; };

    // ① Constrói SVG imediatamente (síncrono) para que os elementos
    //    existam antes do IntersectionObserver disparar a animação
    if (isMobile()) {
      requestAnimationFrame(function() { drawMobileDetailsSVG(root); });
    } else {
      buildDesktopSVG(root);
    }

    // ② IntersectionObserver na seção → dispara draw-on do SVG desktop
    var sectionObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          root.classList.add('anim-go');
          if (!isMobile()) animateDesktopSVG(root);
          sectionObs.unobserve(root);
        }
      });
    }, { threshold: 0.12 });
    sectionObs.observe(root);

    // ③ Callouts: fade-in com delay pós-SVG
    var calloutObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          calloutObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.10 });

    root.querySelectorAll('[data-details-anim]').forEach(function(el, i) {
      var base = isMobile() ? 0.12 : 0.65;
      el.style.transitionDelay = (base + i * 0.13) + 's';
      calloutObs.observe(el);
    });

    // ④ Rebuild no resize
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (isMobile()) {
          drawMobileDetailsSVG(root);
        } else {
          buildDesktopSVG(root);
        }
      }, 220);
    });
  }

  document.querySelectorAll('[data-details-section]').forEach(initDetailsSection);

  // Qty steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
    var min = parseInt(input.min || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Search Modal ────────────────────────────── */
  (function () {
    var overlay   = document.getElementById('search-modal-overlay');
    var modal     = document.getElementById('search-modal');
    var input     = document.getElementById('search-modal-input');
    var closeBtn  = document.getElementById('search-modal-close');
    var body      = document.getElementById('search-modal-body');
    if (!overlay || !modal || !input) return;

    var debounceTimer = null;
    var lastQuery = '';

    function openModal() {
      overlay.classList.add('is-open');
      modal.classList.add('is-open');
      overlay.removeAttribute('aria-hidden');
      setTimeout(function () { input.focus(); }, 80);
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      modal.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      input.value = '';
      lastQuery = '';
      body.innerHTML = '<p class="search-modal__hint">Digite para buscar produtos</p>';
    }

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    function fmt(val) {
      var n = parseFloat(String(val).replace(',', '.'));
      if (isNaN(n)) return '';
      /* price_min = integer cents (4490 = R$44,90); float string = already in reais */
      var amount = (Number.isInteger(n) && n >= 100) ? n / 100 : n;
      return 'R$ ' + amount.toFixed(2).replace('.', ',');
    }

    function renderResults(products, query) {
      if (!products || products.length === 0) {
        body.innerHTML = '<p class="search-modal__empty">Nenhum resultado para "' + query + '"</p>';
        return;
      }
      var html = '<p class="search-modal__hint">' + products.length + ' resultado' + (products.length !== 1 ? 's' : '') + '</p>';
      html += '<div class="search-modal__grid">';
      products.forEach(function (p) {
        /* Image — prefer featured_image, fall back to first image */
        var imgObj = p.featured_image || (p.images && p.images[0]) || null;
        var img = imgObj ? (imgObj.url || imgObj) : '';
        /* Append Shopify image size param */
        if (img) img = img.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_400x$1');
        if (!img && typeof imgObj === 'string') img = imgObj;

        /* Price — price_min is in cents; price may be a pre-formatted string */
        var priceVal = (p.price_min !== undefined) ? p.price_min : p.price;
        var priceStr = '';
        if (typeof priceVal === 'number') {
          priceStr = fmt(priceVal);
        } else if (typeof priceVal === 'string' && priceVal) {
          priceStr = priceVal; /* already formatted by Shopify */
        }

        html += '<a class="search-modal__item" href="' + p.url + '">';
        if (img) {
          html += '<img class="search-modal__item-img" src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="200" height="200">';
        } else {
          html += '<div class="search-modal__item-img"></div>';
        }
        html += '<span class="search-modal__item-title">' + (p.title || '') + '</span>';
        if (priceStr) html += '<span class="search-modal__item-price">' + priceStr + '</span>';
        html += '</a>';
      });
      html += '</div>';
      html += '<a class="search-modal__view-all" href="/search?type=product&q=' + encodeURIComponent(query) + '">Ver todos os resultados →</a>';
      body.innerHTML = html;
    }

    function showSpinner() {
      body.innerHTML = '<div class="search-modal__spinner">' +
        '<div class="search-modal__spinner-dot"></div>' +
        '<div class="search-modal__spinner-dot"></div>' +
        '<div class="search-modal__spinner-dot"></div>' +
        '</div>';
    }

    function doSearch(q) {
      if (q === lastQuery) return;
      lastQuery = q;
      if (!q || q.length < 2) {
        body.innerHTML = '<p class="search-modal__hint">Digite para buscar produtos</p>';
        return;
      }
      showSpinner();
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, q);
        })
        .catch(function () {
          body.innerHTML = '<p class="search-modal__empty">Erro ao buscar. Tente novamente.</p>';
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { doSearch(q); }, 280);
    });
  })();

})();
